export default __webpack_public_path__ + "static/media/icon-calc.53ea67fe.svg";